module.exports = __webpack_public_path__ + "static/media/logo-aciso.13d95bc3.png";